import { render, staticRenderFns } from "./locations-tab.vue?vue&type=template&id=5785576b"
import script from "./locations-tab.vue?vue&type=script&lang=js"
export * from "./locations-tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports